import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

export type SocialAccount = {
  provider: "google" | "apple";
  email: string;
  name: string;
};

export function useGetSocialAccounts(enabled: boolean = true) {
  return useQuery<SocialAccount[]>({
    queryKey: ["socialAccounts"],
    queryFn: async () => {
      const response = await axiosInstance.get("/auth/social-accounts");
      return response.data.data;
    },
    enabled,
  });
}
